export function settingResource(setting) {
    return {
        id: setting.id,
        name: setting.name,
        value: setting.value
    };
}
